import { getApiHost } from 'base/api_host';
import { Icon } from 'base/ui/icon';
import { IconChecked, IconError, IconOption, IconStars } from 'base/ui/icons';
import { TextRegular } from 'base/ui/typography';
import React, { useEffect, useState } from 'react';
import { ClientMessage } from './blocks_service';
import styles from './network_checker.css';

export const NetworkCheckerPage = () => {
  const [connected, setConnected] = useState(false);
  const [sentPing, setSentPing] = useState(false);
  const [receivedPong, setReceivedPong] = useState(false);

  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [timedOut, setTimedOut] = useState(false);

  const [connectionMs, setConnectionMs] = useState<number | null>(null);
  const [pongMs, setPongMs] = useState<number | null>(null);

  useEffect(() => {
    const startTime = Date.now();

    const apiHost = getApiHost();
    const ws = new WebSocket('ws' + apiHost.slice(4) + 'ws/blocks/project/');

    const timeout = setTimeout(() => {
      setTimedOut(true);
      ws.close();
    }, 10_000);

    ws.addEventListener('close', (event) => {
      clearTimeout(timeout);
      if (!event.wasClean) {
        setError(`${event.code}`);
      }
    });

    ws.addEventListener('open', () => {
      setConnected(true);

      const connectedTime = Date.now();
      setConnectionMs(connectedTime - startTime);

      const pingMessage: ClientMessage = { type: 'ping' };
      ws.send(JSON.stringify(pingMessage));

      setSentPing(true);

      ws.addEventListener('message', (event) => {
        const message = JSON.parse(event.data);
        if (message.type === 'pong') {
          setReceivedPong(true);

          setPongMs(Date.now() - connectedTime);

          ws.close();

          setSuccess(true);
        }
      });
    });
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.row}>
        {connected ? (
          <Icon icon={IconChecked} color="colorGreen" />
        ) : (
          <Icon icon={IconOption} color="colorGrey" />
        )}
        <TextRegular>
          Connected {connectionMs !== null && ` (${connectionMs}ms)`}
        </TextRegular>
      </div>
      <div className={styles.row}>
        {sentPing ? (
          <Icon icon={IconChecked} color="colorGreen" />
        ) : (
          <Icon icon={IconOption} color="colorGrey" />
        )}
        <TextRegular>Sent ping</TextRegular>
      </div>
      <div className={styles.row}>
        {receivedPong ? (
          <Icon icon={IconChecked} color="colorGreen" />
        ) : (
          <Icon icon={IconOption} color="colorGrey" />
        )}
        <TextRegular>
          Received pong {pongMs !== null && ` (${pongMs}ms)`}
        </TextRegular>
      </div>
      {success ? (
        <div className={styles.row}>
          <Icon icon={IconStars} color="colorGrey" />
          <TextRegular>
            Success! You have a good network connection to the Relume server.
          </TextRegular>
        </div>
      ) : timedOut ? (
        <div className={styles.row}>
          <Icon icon={IconError} color="colorRed" />
          <TextRegular>Timed out</TextRegular>
        </div>
      ) : error ? (
        <div className={styles.row}>
          <Icon icon={IconError} color="colorRed" />
          <TextRegular>Error: {error}</TextRegular>
        </div>
      ) : null}
    </div>
  );
};
